export const SPLIT_ON_TERM = 0;
export const TAKE_FIRST_CHARACTERS = 1;
export const TAKE_LAST_CHARACTERS = 2;
export const REMOVE_TERM = 3;
